import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String, interval: { type: Number, default: 2000 } };

  connect() {
    this.poll();
  }

  disconnect() {
    this.stopPolling();
  }

  poll() {
    this.timer = setInterval(() => this.checkStatus(), this.intervalValue);
  }

  stopPolling() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  async checkStatus() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "text/vnd.turbo-stream.html" },
      });
      if (response.ok) {
        const html = await response.text();
        Turbo.renderStreamMessage(html);
        // Check if status is no longer "uploading" — stop polling
        if (!html.includes("Uploading")) {
          this.stopPolling();
        }
      }
    } catch (e) {
      // silently retry on next interval
    }
  }
}
